import { Construction } from "lucide-react";

import "./PlaceholderPage.css";

export interface PlaceholderPageProps {
  readonly title: string;
  readonly description?: string;
}

/**
 * Shared "coming soon" page used by every admin route whose content
 * has not shipped yet. Rendered inside the HubSidebarLayout shell so
 * the operator keeps the sidebar + topbar chrome.
 */
export function PlaceholderPage({
  title,
  description = "This area is coming soon. Check back shortly.",
}: PlaceholderPageProps): JSX.Element {
  return (
    <section className="placeholder-page">
      <div className="placeholder-page__card">
        <div className="placeholder-page__icon-box">
          <Construction size={28} aria-hidden="true" />
        </div>
        <h1 className="placeholder-page__title">{title}</h1>
        <p className="placeholder-page__description">{description}</p>
      </div>
    </section>
  );
}
